import React from 'react';
import "./../App.css";
import {Box, List, ListItem, ListItemIcon, ListItemText, Divider} from '@material-ui/core';
//import Box from '@mui/material/Box';
//import List from '@mui/material/List';
//import ListItem from '@mui/material/ListItem';
//import ListItemIcon from '@mui/material/ListItemIcon';
//import ListItemText from '@mui/material/ListItemText';
//import Divider from '@mui/material/Divider';
//import InboxIcon from '@mui/icons-material/Inbox';
import BallotOutlined from '@material-ui/icons/BallotOutlined';
import CardGiftcardOutlined from '@material-ui/icons/CardGiftcardOutlined';
import ArrowBackOutlined from '@material-ui/icons/ArrowBackOutlined';
import LocalShippingOutlined from '@material-ui/icons/LocalShippingOutlined';
import PrintOutlined from '@material-ui/icons/PrintOutlined';
import { Link } from 'react-router-dom'


class Outbound extends React.Component {
    constructor(props) {
        super(props);

        this.state = {            
        };

    }

    handleChange(e) {
    }

    handleSubmit(e) {
        e.preventDefault();
    }

    render() {
        const { location: { pathname } } = this.props
        return (
            
            <Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                <nav aria-label="main mailbox folders">
                    <List>
                    <ListItem  button component={Link} to="/picking" selected={'/picking' === pathname}>
                        
                        <ListItemIcon>
                            <BallotOutlined />
                        </ListItemIcon>
                        <ListItemText primary="Picking" />
                        
                    </ListItem>
                    <ListItem  button component={Link} to="/packing" selected={'/packing' === pathname}>
                        
                        <ListItemIcon>
                            <CardGiftcardOutlined />
                        </ListItemIcon>
                        <ListItemText primary="Packing" />
                        
                    </ListItem>
                    <ListItem  button component={Link} to="/shipping" selected={'/shipping' === pathname}>
                        
                        <ListItemIcon>
                            <LocalShippingOutlined />
                        </ListItemIcon>
                        <ListItemText primary="Shipping" />
                        
                    </ListItem>
                    {/*
                    <ListItem  button>
                        
                        <ListItemIcon>
                            <ArrowBackOutlined />
                        </ListItemIcon>
                        <ListItemText primary="Put Back Inventory" />
                        
                    </ListItem>         
                               
                    <ListItem  button>
                        
                        <ListItemIcon>
                            <PrintOutlined />
                        </ListItemIcon>
                        <ListItemText primary="Print BOL" />
                        
                    </ListItem>
                    */}
                    </List>
                </nav>
            </Box>      
        );
    }
}
export default Outbound;